var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.25 7.5H33C26.6994 7.5 23.5491 7.5 21.1426 8.72618C19.0258 9.80475 17.3048 11.5258 16.2262 13.6426C15 16.0491 15 19.1994 15 25.5V64.5C15 70.8006 15 73.9509 16.2262 76.3574C17.3048 78.4742 19.0258 80.1952 21.1426 81.2738C23.5491 82.5 26.6994 82.5 33 82.5H57C63.3006 82.5 66.4509 82.5 68.8574 81.2738C70.9742 80.1952 72.6952 78.4742 73.7738 76.3574C75 73.9509 75 70.8006 75 64.5V26.25L56.25 7.5ZM52.5 13.125V27C52.5 28.0501 52.5 28.5751 52.7044 28.9762C52.8841 29.329 53.171 29.6159 53.5238 29.7956C53.9249 30 54.4499 30 55.5 30H69.375L52.5 13.125ZM30 30C27.9289 30 26.25 31.6789 26.25 33.75C26.25 35.8211 27.9289 37.5 30 37.5H33.75C35.8211 37.5 37.5 35.8211 37.5 33.75C37.5 31.6789 35.8211 30 33.75 30H30ZM30 45C27.9289 45 26.25 46.6789 26.25 48.75C26.25 50.8211 27.9289 52.5 30 52.5H60C62.0711 52.5 63.75 50.8211 63.75 48.75C63.75 46.6789 62.0711 45 60 45H30ZM30 60C27.9289 60 26.25 61.6789 26.25 63.75C26.25 65.8211 27.9289 67.5 30 67.5H60C62.0711 67.5 63.75 65.8211 63.75 63.75C63.75 61.6789 62.0711 60 60 60H30Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAlt);
export default __webpack_public_path__ + "static/media/file_alt.8a8e492016d575ecd8e3f96f00418044.svg";
export { ForwardRef as ReactComponent };